import React from 'react';
import { SubMenuListItem } from '../../models/subMenuListItem';
import { List } from '@mui/material';
import CustomMenuItem from './CustomMenu';

interface ISubMenuList {
  subMenu: SubMenuListItem[];
  onClick: any;
}

const SubMenuList = (props: ISubMenuList) => {
  const { subMenu, onClick } = props;

  if (!subMenu?.length) {
    throw new Error('subMenu cannot be undefined or empty.');
  }

  return (
      <List disablePadding>
        {subMenu.map((obj: any, i: number) => (
          <CustomMenuItem
            key={i}
            obj={obj}
            onClick={onClick}
          />
        ))}
      </List>
  );
};

export default SubMenuList;
